import React from 'react';
import styles from './Home.module.css';
import { Link } from 'react-router-dom';
import { FiArrowRightCircle } from "react-icons/fi";
import Header from '../../components/Header/Header';

export default class Home extends React.Component {

    constructor(props) {
        super(props);

        this.appLink = 'https://apps.apple.com/us/app/snapquizai/id6740707942';

        this.categoryList = [
            ['14', 'General Biology'],
            ['15', 'Cell Biology'],
            ['16', 'Molecular Biology'],
            ['17', 'Genetics'],
            ['18', 'Ecology'],
            ['19', 'Evolutionary Biology'],
            ['20', 'Microbiology'],
            ['21', 'Plant Biology / Botany'],
            ['22', 'Animal Biology / Zoology'],
            ['23', 'Physiology'],
            ['24', 'Developmental Biology'],
            ['25', 'Laboratory Techniques in Biology'],
            ['26', 'Field Studies in Biology'],
            ['27', 'Research Methods in Biology'],
            ['28', 'Capstone Biology Project'],
        ];

        if ( this.iOS() ) {
            this.sectionPic1Style = styles.sectionPic1Safari;
            this.sectionPic2Style = styles.sectionPic2Safari;
        }
        else {
            this.sectionPic1Style = styles.sectionPic1;
            this.sectionPic2Style = styles.sectionPic2;
        }

        this.starSVG = (
            <svg
                width={18}
                height={18}
                fill="#fff"
                stroke="#fff"
                viewBox="0 0 47.94 47.94"
                style={{ marginRight: 5 }}
            >
                <path
                d="m26.285 2.486 5.407 10.956a2.58 2.58 0 0 0 1.944 1.412l12.091 1.757c2.118.308 2.963 2.91 1.431 4.403l-8.749 8.528a2.582 2.582 0 0 0-.742 2.285l2.065 12.042c.362 2.109-1.852 3.717-3.746 2.722l-10.814-5.685a2.585 2.585 0 0 0-2.403 0l-10.814 5.685c-1.894.996-4.108-.613-3.746-2.722l2.065-12.042a2.582 2.582 0 0 0-.742-2.285L.783 21.014c-1.532-1.494-.687-4.096 1.431-4.403l12.091-1.757a2.58 2.58 0 0 0 1.944-1.412l5.407-10.956c.946-1.919 3.682-1.919 4.629 0z"
                style={{
                    fill: "#fff",
                }}
                />
            </svg>
        );

        this.starSVGArray = [
            this.starSVG,
            this.starSVG,
            this.starSVG,
            this.starSVG,
            this.starSVG
        ];
    };

    componentDidMount() {
    };
    
    iOS = () => {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    };

    render() {
        return (
            <div className={styles.rootView}>
                {/* <img src={require('../../assets/animation.gif')} className={styles.background} /> */}
                <div className={styles.background} />

                <Header />

                <div className={styles.content}>
                    {/* <div className={styles.logoView}>
                        <img className={styles.logoImage} src={require('../../assets/logo.png')} />
                    </div> */}

                    <div className={styles.title}>
                        Ace your Biology exams
                    </div>
                    <div className={styles.subtitle}>
                        with more than 10,000 free quiz questions!
                    </div>

                    <div className={styles.subtitle}>
                        What do you want to quiz yourself on today?
                    </div>

                    {/* <div className={styles.subtitle}>
                        Make quizzes from your
                        <div className={styles.subtitleBold}>notes, and books!</div>
                    </div> */}

                    {/* <a href={this.appLink}>
                        <img src={require('../../assets/appstore.png')} className={styles.appstore} />
                    </a> */}

                    {
                        this.categoryList.map(item => {
                            const categoryID = item[0];
                            const title = item[1];
                            return (
                                <a key={`studyItem_${categoryID}`} href={`/category/${categoryID}`}>
                                    <div className={styles.studyItem}>
                                        <div>{title}</div>
                                        <FiArrowRightCircle color='#032d73' />
                                    </div>
                                </a>
                            )
                        })
                    }

                    <div className={styles.footer}>
                        {/* <a href='mailto:vibegameapp@gmail.com' className={styles.link}>Help</a> */}
                        {/* <Link to="/help" className={styles.link}>Help</Link> */}
                        <Link to="/terms" className={styles.link}>Terms</Link>
                        <Link to="/privacy" className={styles.link}>Privacy</Link>
                    </div>
                    <div className={styles.copyright}>© KVK LLC. 2025</div>
                </div>
            </div>
        );
    };
};